/**
 * Goods Receipting rows are grouped by supplier + PO + placedVia +
 * orderedDate, so one PO can come back as two rows. Key each row by its
 * first order line id as well so React/antd keys stay unique. Some rows'
 * lines carry no id, so fall back to the rest of the grouping
 * (placedVia + orderedDate), which is unique per row by construction.
 * No row index: every key lookup (expand, drafts, retro edit, save) must
 * rebuild the same key from the record alone.
 */
export const getReceiptingPoKey = (purchaseOrderNumber, supplierId) =>
  `${purchaseOrderNumber}${supplierId}`

const normaliseOrderedDate = value => {
  if (value === undefined || value === null || value === '') return ''
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? String(value) : date.toISOString()
}

export const getReceiptingRowKey = record => {
  const base = getReceiptingPoKey(
    record?.purchaseOrderNumber,
    record?.supplier?._id,
  )
  const firstLine = (record?.orders || [])[0]
  const orderId =
    firstLine?.orderId || firstLine?._id || (record?.orderIds || [])[0]
  if (orderId) return `${base}#${orderId}`
  const placedVia = record?.placedVia || ''
  const orderedDate = normaliseOrderedDate(record?.orderedDate)
  return placedVia || orderedDate ? `${base}#${placedVia}@${orderedDate}` : base
}

/** True when a row key belongs to this PO + supplier (any of its rows). */
export const isReceiptingRowKeyForPo = (
  key,
  purchaseOrderNumber,
  supplierId,
) => {
  const base = getReceiptingPoKey(purchaseOrderNumber, supplierId)
  const value = String(key)
  return value === base || value.startsWith(`${base}#`)
}
